<template>
    <div
        class="relative"
        ref="wrapper"
    >
        <label
            class="select-filter"
            :class="{
                'select-filter-active': active,
            }"
            @click="toggle"
        >
            <p class="label label-small">
                Where
            </p>

            <p class="select-filter-note">
                <span
                    v-if="selected.length"
                    v-html="selectedByName.join(', ')"
                ></span>
                <template v-else>
                    Select region(s)
                </template>
            </p>
        </label>

        <DeleteButton
            v-if="selected.length"
            class="absolute top-1/2 right-3 xl:right-5 -translate-y-1/2"
            @click.prevent="clear(); emit('close');"
        />

        <Transition>
            <Dropdown
                v-if="regions.length"
                title="Regions"
                class="w-full"
                v-model:active="active"
                @close="active = false"
            >
                <ul
                    class="leading-none flex flex-col space-y-1.5 sm:space-y-2.5"
                    :class="{ 'opacity-60 pointer-events-none': loading }"
                >
                    <li
                        v-for="region in regions"
                        :key="region.id"
                    >
                        <label
                            :for="`region-${region.id}`"
                            class="flex items-center gap-2.5 text-xsss sm:text-xs"
                        >
                            <input
                                :id="`region-${region.id}`"
                                class="checkbox"
                                type="checkbox"
                                name="regions[]"
                                :value="region.slug"
                                @change="selectOption(region.slug)"
                                :checked="props.selected.includes(region.slug)"
                            >
                            <span
                                class="pt-1"
                                v-html="region.name"
                            ></span>
                        </label>
                    </li>
                </ul>
            </Dropdown>
        </Transition>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, useTemplateRef, watch } from 'vue';

    import DeleteButton from '@js/src/components/DeleteButton.vue';
    import Dropdown from '@js/src/components/Dropdown.vue';

    const emit = defineEmits([
        'selected',
        'close',
    ]);

    const props = defineProps([
        'loading',
        'selected',
    ]);

    const wrapper = useTemplateRef('wrapper');

    const regions = ref(Filters.regions);
    const active = ref(false);

    const selectedByName = computed(() => {
        return regions.value.filter(region => props.selected.includes(region.slug)).map(region => region.name);
    });

    watch(active, (value) => {
        if (!value) {
            emit('close');
        }
    });

    function toggle() {
        active.value = !active.value;
    }

    function clear() {
        emit('selected', []);
    }

    function selectOption(value) {
        let selected = props.selected;

        if (selected.includes(value)) {
            selected = selected.filter((item) => item !== value);
        } else {
            selected.push(value);
        }

        emit('selected', selected);
    }

    onMounted(() => {
        window.addEventListener('click', function (e) {
            if (wrapper.value && !wrapper.value.contains(e.target)) {
                active.value = false;
            }
        });
    });
</script>
